// Import Swiper and modules
import Swiper, { Navigation, Pagination, Thumbs, FreeMode } from 'swiper';

let swipe1 = new Swiper('.block.elections .items', {
    slidesPerView : 1,
    spaceBetween: 30,
    breakpoints:{
        956: {
            slidesPerView: 3,
        },
        786:{
            slidesPerView: 2,
        }
    }
});


let swipe2 = new Swiper('.block-pratique-vote .swiper', {
    slidesPerView : 1,
    spaceBetween: 20,
    breakpoints:{
        1300:{
            slidesPerView: 3,
        },
        992:{
            slidesPerView: 2,
        }
    }
});
